import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AccountService } from '../services/account.service';
import { IItem } from '../services/account.service';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { AddressEditorModalComponent } from 'src/app/shared/components/address-editor-modal/address-editor-modal.component';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { AlertController, ModalController } from '@ionic/angular';
import { finalize,publishReplay, refCount } from 'rxjs/operators';
import { MenuService } from 'src/app/store/services/menu.service';
import { IonSelect } from '@ionic/angular';
import { IGeopoint } from 'src/app/store/pages/list-page/list-page.component';
import { GeolocationHelpers } from 'src/app/helpers/geolocataion-helpers';
import { GoogleApiService } from 'src/app/shared/services/google-api.service';
import { StoreService } from 'src/app/store/services/store.service';
import { Storage } from '@ionic/storage';
import { TranslationService } from 'src/app/shared/services/translation.service';
export enum CouponsType {
  DOLLAR = 1,
  PERCENT = 2,
  REWARD_FIX = 3,
  REWARD_RATIO= 4
}
@Component({
    selector: 'app-view-offer',
    templateUrl: './view-offer.component.html',
    styleUrls: ['./view-offer.component.scss'],
    standalone: false
})
export class ViewOfferComponent implements OnInit {
  currentSegment: string = 'barcode';
  @ViewChild('selectOrderType',{ static: false }) selectOrderType: IonSelect;
  @ViewChild('days') days: ElementRef;
  @ViewChild('hours') hours: ElementRef;
  @ViewChild('minutes') minutes: ElementRef;
  @ViewChild('seconds') seconds: ElementRef;
  @ViewChild('fullCoupon') fullCoupon: ElementRef;
  @ViewChild('couponFront') couponFront: ElementRef;
  @ViewChild('couponBack') couponBack: ElementRef;
  lang: string='fr';
  couponsType=CouponsType;
  numberOfDays=1;
  clearInterval: any;
  savedCoupons=[];
  couponCode: number;
  isOrder: boolean=false;
  orderTypes=[ 
    {
      type: { translations : {
        fr: 'Livraison',
        en: 'Delivery'
      }  }, 
      value: 'delivery'
    },
    {
      type: { translations : {
        fr: 'Cueillette',
        en: 'Pickup'
      }
    },
      value: 'pickup'
    },
  
      // {
    //   type: { translations : {
    //     fr: 'Expédition',
    //     en: 'Shipping'
    //   },
    // },
     //value: 'shipping'
   // },
  ]
  globalCouponCode: number;
  isGlobalCouponCode: boolean=false;
  isReachedUsageLimit: boolean = false;
  constructor(private loader: LoaderService,
    private modalCtrl: ModalController,
    private account: AccountService, 
    private route: ActivatedRoute, 
    private googleApiService: GoogleApiService,
    private router: Router,
    public menuService: MenuService,
    //public translateService: TranslateService,
    private alertCtrl: AlertController,
    private storage: Storage,
    private storeService: StoreService,
    private translationService: TranslationService
    )
   { }
    coupon: IItem;
    couponNum: string;
    subscription: Subscription;
    private _geopoint: IGeopoint;
    get geopoint(): IGeopoint {
      return this._geopoint;
    }

    set geopoint(value: IGeopoint) {
      this._geopoint = value;
      if (!value)
        return;

   this.menuService.store._distance=GeolocationHelpers.distance(value.latitude, value.longitude, this.menuService.store.address.latitude, this.menuService.store.address.longitude);
}
        ngOnInit()
        {
      
              this.lang = this.translationService.getLanguage();

              if(localStorage['StoreId'])
              {
                this.menuService.getStore(localStorage['StoreId'],null)
              }
              
              let resolvedOffer: IItem[]=this.route.snapshot.data['resolvedOffer'];
              const index=this.route.snapshot.paramMap.get('id');
              this.coupon=resolvedOffer.find(coupon=>coupon.Id===parseInt(index));

              let linked = false;
              if(!localStorage['linkCoupon'])
              {
                this.linkCoupons(index);
                linked = true;
              }
              else 
              {
                this.savedCoupons=JSON.parse(localStorage['linkCoupon']);
                if(!this.savedCoupons.includes(index))
                {
                  this.linkCoupons(index);
                  linked = true;
                }
              }

              if (!linked) {
                this.getDetailCoupon(index);
              }
              
              if(this.coupon)
              {
                    let couponNumber=this.coupon.Sku.toString();
                    let temp=couponNumber.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim(); //Regex to put space after every 4 characters.
                    this.couponNum=temp;
              }  
              else
              {
                      this.router.navigate(['/account/offers'])
              }
      }
      ngAfterViewInit()
      {
          this.startCountDown();
      }
    
      checkout()
      {
      if(localStorage['cartStorage'] && localStorage['StoreId'])
      {
        let items=(JSON.parse(localStorage['cartStorage']));
        if(items.length==0)
            {
              this.noCart();
              return;
            }
            let orderType = localStorage.getItem('orderType');

            if (orderType != null) {
              this.menuService.order._deliveryType= orderType == 'pickup' ? "pickup" : "delivery";
              let availability=true;
              items.map(item=>{
                  
                  if(!item.isDelivery && this.menuService.order._deliveryType==='delivery')
                  { 
                    availability=false;
                  }
  
              });
                if(!availability)
                {
                  this.notAvailable(this.translationService.translate('Coupon.ItemNotAvailable'), this.translationService.translate('Coupon.ItemNotAvailableDelivery'))
                  return
                } 
              
                this.couponCheckout();
            } else {
              this.selectOrderType.open();
            }        
        }
      
        else {
          this.noCart();
          return;
          }
      }

        chooseOrderType(e)
        {
        this.menuService.order._deliveryType=e.detail.value;

        if(e.detail.value)
        {
          if(this.menuService.order._deliveryType==='delivery')
          {
            this.beginChangeAddress();
          }
          else {

            this.checkout();

          }
          if(e.detail.value=='delivery')
          {
            this.storage.get('deliveryAddress').then(address=>{
              if(address)
              {
                this.couponCheckout();
              }
              else {
                this.beginChangeAddress();  
              }
                  
              })
          }
          else if(e.detail.value=='pickup')
          {
            this.couponCheckout();
          }
          this.selectOrderType.value='';
        }
      }

        
      couponCheckout()
      {
            if(this.isGlobalCouponCode)
            {
              localStorage['Coupon']=this.globalCouponCode;
            }
            else {
              localStorage['Coupon']=this.couponCode;
            }
                setTimeout(() => {
                  this.menuService.orderCheckout();
                }, 500);
      }

      noCart()
      {
        this.alertCtrl.create({
          header: this.translationService.translate('Coupon.NoCart'),
          message: this.translationService.translate('Coupon.NoCartDescription'),
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                
              }
            }
          ]
        }).then(al=>{
          al.present();
        });
      }
      
      notAvailable(header,message)
      {
      this.alertCtrl.create({
        header: header,
        message: message,
        buttons: [
          {
            text: 'Ok',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
              
            }
          }
        ]
      }).then(al=>{
        al.present();
      });
      }

       
      async beginChangeAddress() {
      const modal = await this.modalCtrl.create({
        component: AddressEditorModalComponent,
        componentProps: {
          skipProvinceValidation: true
        }
      });
  
      modal
        .onDidDismiss()
        .then(async (result) => {
          if (!result.data)
            return;
          if(result.data)
          {
            this.storage.set('deliveryAddress',result.data);
            this.googleApiService.getAddressGeometry(result.data)
            .subscribe((result) => {
              this.geopoint = {
                latitude: result.lat,
                longitude: result.lng
              }
              this.menuService.store = this.storeService.setDeliveryPrice(this.menuService.store, result.data,this.geopoint);

              if(this.menuService.store._distance>this.menuService.store.deliveryRadius) 
              {
                this.storeTooFar(); 
                return;
              }
              else {
                this.couponCheckout()          
              }
            });
        
          }
        });
  
        await modal.present();
      }
         async linkCoupons(id)
         {
            
            const loader = await this.loader.create();
            await loader.present();
           this.account.linkCoupons(id).pipe(
              finalize(()=>{
                loader.dismiss();
              })
            ).subscribe(res=>{
                if(res==null)
                {
                  this.router.navigate(['/account/offers'])
                }
              this.savedCoupons.push(id);
              localStorage['linkCoupon']=JSON.stringify(this.savedCoupons);
              this.getDetailCoupon(id);
            })
         }

         async getDetailCoupon(id)
         { 
          const loader = await this.loader.create();
          await loader.present();
          this.account.GetDetailedCoupons(id).pipe(finalize(()=>{
            loader.dismiss();
          })).subscribe(res=>{
            if (null == res) {
              //coupon was already been used/ reached the usage limit
              this.isReachedUsageLimit = true;
            } else {
              this.couponCode=res.CouponCode;
              this.globalCouponCode=res.GlobalCouponCode;
              this.isGlobalCouponCode=res.IsGlobalCouponCode
            }
          })

         }

         startCountDown()
         {
           this.clearInterval=setInterval(() => {
            this.timeCountDown();   
           }, 1000);
         }
      
         change(value: string)
         {
           this.currentSegment=value;
         }
    flip()
    {
      
            let fullCoupon=this.fullCoupon.nativeElement;
            let front=this.couponFront.nativeElement;
            let back=this.couponBack.nativeElement;
            back.classList.remove('hide');
            back.style.height=front.offsetHeight+'px';
            fullCoupon.removeAttribute("id");  
            fullCoupon.setAttribute("id","b");
    }
    track(e: Event)
    {
              
              const target = e.target as HTMLInputElement;
              let back=this.couponBack.nativeElement;
              if(target.id==="container" || target.id==="b")
              {

                let fullCoupon=this.fullCoupon.nativeElement;
                back.classList.add('hide');
                fullCoupon.removeAttribute("id");
                fullCoupon.setAttribute("id","c");
              
              }
    }
    turnBack()
    { 
   
      let back=this.couponBack.nativeElement; 
      let fullCoupon=this.fullCoupon.nativeElement;
      back.classList.add('hide');
      fullCoupon.removeAttribute("id");
      fullCoupon.setAttribute("id","c");

    }
    timeCountDown()
    {
      if(this.coupon)
      {
        let presentDate=new Date();
        let expirationDate=new Date(this.coupon.ExpirationDate);
        let remainingTime=expirationDate.getTime()-presentDate.getTime();
        this.numberOfDays=Math.floor(remainingTime / (1000 * 60 * 60 * 24));
        if(this.numberOfDays>0)
        {
          let days= this.translationService.getLanguage() =='fr' ? ' Jours' : ' Days';
          this.numberOfDays<10 ? this.days.nativeElement.innerHTML = "0"+this.numberOfDays+days : this.days.nativeElement.innerHTML=this.numberOfDays+days;
        }
       
        if(this.numberOfDays==0)
        {
          
          this.days.nativeElement.style.display="none";
          
          let numberOfHours= Math.floor((remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let numberOfMinutes= Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
          let numberOfSeconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
  
          if(numberOfHours==0 && numberOfMinutes==0 && numberOfSeconds==0)
          { 
            clearInterval(this.clearInterval);
            this.hours.nativeElement.innerHTML=" Sorry offer has been expired!"
            this.minutes.nativeElement.style.display="none";
            this.seconds.nativeElement.style.display="none";
          }
          else
          {
            numberOfHours<10 ?  this.hours.nativeElement.innerHTML = "0"+numberOfHours+":" : this.hours.nativeElement.innerHTML=numberOfHours+":";
            numberOfMinutes<10 ?  this.minutes.nativeElement.innerHTML = "0"+numberOfMinutes+":" : this.minutes.nativeElement.innerHTML=numberOfMinutes+":";
            numberOfSeconds<10 ? this.seconds.nativeElement.innerHTML="0"+numberOfSeconds : this.seconds.nativeElement.innerHTML=numberOfSeconds;
          }
        
        }
      }
    }
    storeTooFar()
    {
        this.alertCtrl.create({
          header: this.translationService.translate('Coupon.CannotDeliver'),
          message: this.translationService.translate('Coupon.ChangeAddress'),
          buttons: [
            {
              text: 'Okay',
              role: 'cancel',
              cssClass: 'secondary',
              handler: () => {
                
              }
            }
          ]
        }).then(al=>{
          al.present();
        });
        this.selectOrderType.value='';
        return;
    }
    getCouponTranslationName(coupon: any) {
      if (coupon[this.translationService.getLanguage()]) {
        return coupon[this.translationService.getLanguage()].Name;
      } else {
        if (coupon) {
          for (const property in coupon) {
            //If lang translation is not found, return the first one
            return coupon[property].Name;   
          }  
        }
      }
    }
    getCouponTranslationTerms(coupon: any) {

      if (coupon[this.translationService.getLanguage()]) {
        return coupon[this.translationService.getLanguage()].Terms;

      } else {
        if (coupon) {
          for (const property in coupon) {
            //If lang translation is not found, return the first one
            return coupon[property].Terms;   
          }  
        }
      }
   
    }

    transform(value: number) {
      var test = "";
      if (value != null) {
        test = value.toString();
        test = test.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
        return test;
      }
      return value;
    }
  }
